export default {
  head_scripts: {
    title: 'Head-skriptit',
  },
  body_noscripts: {
    title: 'Body-noscriptit',
    description: 'Lisää koodi heti body-tagin avauksen jälkeen',
  },
  google_site_verification: {
    title: 'Googlen sivuston vahvistus',
    label: 'Googlen sivuston vahvistuskoodi',
  },
  buttons: {
    save: 'Tallenna',
  },
};
